exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".account-and-billing-icon-1{fill:#1e4e69}.account-and-billing-icon-2{fill:none}.account-and-billing-icon-3{fill:#bfe7e3}.account-and-billing-icon-4{fill:#72cac2}.account-and-billing-icon-5{fill:#fff}\n", ""]);
